<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'

	type LabelVariant = 'primary' | 'error' | 'warning' | 'success' | 'info' | 'favorite' | 'default'

	type Props = {
		variant?: LabelVariant
		label: string
		color?: string
		size?: 'sm' | 'md'
		icon?: IconName
		iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
		maxWidth?: string
		multiline?: boolean
		class?: string
		iconClassName?: string
	}

	const {
		variant = 'info',
		label,
		color,
		icon,
		size = 'md',
		iconSize = 'md',
		maxWidth,
		multiline = false,
		class: className = '',
		iconClassName = ''
	}: Props = $props()
</script>

<div
	class="container {className}"
	class:primary={variant === 'primary'}
	class:success={variant === 'success'}
	class:error={variant === 'error'}
	class:warning={variant === 'warning'}
	class:info={variant === 'info'}
	class:favorite={variant === 'favorite'}
	class:default={variant === 'default'}
	class:custom-color={color !== undefined}
	class:sm={size === 'sm'}
	class:md={size === 'md'}
	class:multiline={maxWidth || multiline}
	style={`${maxWidth ? `max-width: ${maxWidth};` : ''}${color ? `--label-color: ${color};` : ''}` ||
		undefined}
>
	{#if icon}
		<Icon name={icon} size={iconSize} class={iconClassName} />
	{/if}
	<span class="label-text" class:multiline-text={maxWidth || multiline}>{label}</span>
</div>

<style lang="postcss">
	.container {
		@apply inline-flex items-center justify-center font-normal rounded-full w-auto gap-1 px-2 min-w-0;
	}
	.container.sm {
		@apply h-6 text-sm;
	}
	.container.md {
		@apply h-8 text-base;
	}

	.container.multiline {
		@apply py-1 h-auto min-h-6;
	}
	.container.multiline.md {
		@apply min-h-8;
	}

	.label-text {
		@apply inline leading-tight;
		word-wrap: break-word;
		overflow-wrap: break-word;
	}
	.label-text.multiline-text {
		@apply block;
		hyphens: auto;
	}

	.primary {
		@apply bg-[#007ACC0D] text-[#007ACC];
	}
	.info {
		@apply bg-[#26B0FF0D] text-[#1A74A8];
	}
	.error {
		@apply bg-[#E4485B0D] text-[#E4485B];
	}
	.warning {
		@apply bg-[#FFC02E0D] text-[#8F6C1A];
	}
	.success {
		@apply bg-[#0ACC920D] text-[#067A57];
	}
	.favorite {
		@apply bg-[#00498011] text-[#001D33B2];
	}
	.default {
		@apply bg-[#00498006] text-[#001626E5];
	}
	.custom-color {
		color: var(--label-color);
		background-color: color-mix(in srgb, var(--label-color) 8%, transparent);
	}
</style>
